module.exports = __webpack_public_path__ + "img/ico-arrow-next3.a4649be4.svg";